import { ResultsStatus } from '@src/common/types';

export function getResultStatusForEdges(
  success: boolean,
  total: number,
  sourceNodeId: string,
  excessive: number,
  unmanageable: number
) {
  let resultStatus = success ? ResultsStatus.results : ResultsStatus.error;
  if (success && total === 0 && !sourceNodeId) {
    resultStatus = ResultsStatus.noResults;
  }

  if (success && total > excessive) {
    resultStatus = ResultsStatus.excessiveResults;
  }

  if (success && total > unmanageable) {
    resultStatus = ResultsStatus.unmanageableResults;
  }

  return resultStatus;
}
